import { createAuthClient } from '@selfinspectionorg/auth';

/**
 * The auth SDK client. Serves the app on the same origin as the API (`baseURL: ''`),
 * so requests are relative — there is no base-URL env var. `guest` mode because the
 * app is pre-login.
 */
export const authClient = createAuthClient({
  baseURL: '',
  mode: 'guest',
});

/** Authenticated axios instance (carries the SDK's access token). */
export const authApi = authClient.api;

/**
 * @deprecated Use authApi instead
 */
export const publicApi = authApi;
